module.exports = __webpack_public_path__ + "img/danger.921853ee.svg";